import axiosInstance from '../../axiosInstance/axiosInstance';

/**
 * Fetch all Hubs Locations with pagination, search, and category filters
 */
export const getAllHubsLocations = async (page = 1, limit = 10, search = '', categoryId = '', subCategoryId = '', options = {}) => {
    try {
        const params = {
            page,
            search,
            ...(categoryId && { categoryId }),
            ...(subCategoryId && { subCategoryId }),
        };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        const response = await axiosInstance.get('/hubs-locations', {
            params,
            ...options
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetch single Hub Location by ID
 */
export const getHubsLocationById = async (id) => {
    try {
        const response = await axiosInstance.get(`/hubs-locations/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Create a new Hub Location
 */
export const createHubsLocation = async (formData) => {
    try {
        const response = await axiosInstance.post('/hubs-locations', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Update an existing Hub Location
 */
export const updateHubsLocation = async (id, formData) => {
    try {
        const response = await axiosInstance.put(`/hubs-locations/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Create a new city for a state
 */
export const createHubCity = async (data) => {
    try {
        const response = await axiosInstance.post('/hubs-locations/cities', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetch cities of a state by isoCode
 */
export const getHubCitiesByState = async (isoCode) => {
    try {
        const response = await axiosInstance.get(`/hubs-locations/cities/state/${isoCode}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Fetch retreats matching hub criteria for preview and pinning
 * Method: GET /hubs-locations/retreats
 * Port: 3101 (from HAITAPI_PORT / apiUrlOne)
 * Auth Header: Required via authenticate middleware (handled by axiosInstance)
 * Query Parameters: state, location, categoryId, subCategoryId, placementType or type,
 * atmosphereId, featuresId, mealPlanId, surroundingAreasId, thingsInAreaId, languageId, page, limit
 */
export const getHubMatchingRetreats = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/hubs-locations/retreats', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};



